"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressStateToMessageKeyMap = void 0;
const catalog_1 = require("../client/catalog");
exports.progressStateToMessageKeyMap = {
    [catalog_1.CatalogProgressState.Uploading]: 'CATALOG_STATE_UPLOADING',
    [catalog_1.CatalogProgressState.Waiting]: 'CATALOG_STATE_GENERATING_PREVIEW',
    [catalog_1.CatalogProgressState.Importing]: 'CATALOG_STATE_GENERATING_PREVIEW',
    [catalog_1.CatalogProgressState.InitialProductsEnrichment]: 'CATALOG_STATE_INITIAL_ENRICHMENT',
    [catalog_1.CatalogProgressState.Migrating]: 'CATALOG_STATE_MIGRATING',
    [catalog_1.CatalogProgressState.Exporting]: 'CATALOG_STATE_EXPORTING',
    [catalog_1.CatalogProgressState.Error]: 'CATALOG_STATE_ERROR',
};
